module.exports = __webpack_public_path__ + "static/media/speech-bubble.3d940ff0.png";